import { PLANNING_MEETING_FORM_VERSION, SENIOR_PLANNING_2 } from '../constants/general';

function withLabelText(options) {
  return options.map((o) => ({ ...o, label: o.text }));
}

export function getSheet2CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    const v2Map = [
      {
        value: 10,
        text: 'Sheet was thoughtfully completed by student shown by following directions, using complete sentences and basic grammar expectations.',
        disabled: false,
      },
      {
        value: 6,
        text: 'Sheet was completed by student but requires more work. Shown by incomplete sentences, but all questions are answered.',
        disabled: false,
      },
      { value: 2, text: 'Sheet completion needs significant improvement. Missing key information, using one word answers.', disabled: false },
      { value: 0, text: 'Sheet was not completed.', disabled: false },
    ];
    return [{ value: -1, label: 'Select', text: 'Select', disabled: true }, ...withLabelText(v2Map)];
  }
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    ...withLabelText(SENIOR_PLANNING_2.SHEET_2.COMPLETED.OPTIONS.filter((o) => o.value !== -1).map((o) => ({ ...o, disabled: false }))),
  ];
}

export function getSheet2SubmittedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    const v2Map = [
      { value: 5, text: 'Sheet was submitted on time.', disabled: false },
      { value: 3, text: 'Sheet was submitted within 24 hours of due date.', disabled: false },
      { value: 1, text: 'Sheet was submitted between 2 to 3 days after due date.', disabled: false },
      { value: 0, text: 'Sheet was submitted 4 days or more after due date.', disabled: false },
    ];
    return [{ value: -1, label: 'Select', text: 'Select', disabled: true }, ...withLabelText(v2Map)];
  }
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    ...withLabelText(SENIOR_PLANNING_2.SHEET_2.SUBMITTED.OPTIONS.filter((o) => o.value !== -1).map((o) => ({ ...o, disabled: false }))),
  ];
}

export function getSheet2SpeakOptions() {
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    ...SENIOR_PLANNING_2.SHEET_2.SPEAK.OPTIONS.filter((o) => o.value !== -1).map((o) => ({ ...o, disabled: false })),
  ];
}

export function getModule4SubmittedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return withLabelText([
      { value: -1, text: 'Select', disabled: true },
      { value: 8, text: 'Module completed in full by due date; 100% completion status shown in platform', disabled: false },
      { value: 6, text: 'Module mostly completed 75–99%', disabled: false },
      { value: 4, text: 'Module less than 75% complete', disabled: false },
      { value: 0, text: 'Module not started or under 50% complete by the due date', disabled: false },
    ]);
  }
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    ...withLabelText(SENIOR_PLANNING_2.MODULE_4.SUBMITTED.OPTIONS.filter((o) => o.value !== -1).map((o) => ({ ...o, disabled: false }))),
  ];
}

export function getModule4CompletedOptions() {
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    ...SENIOR_PLANNING_2.MODULE_4.COMPLETED.OPTIONS.filter((o) => o.value !== -1).map((o) => ({ ...o, disabled: false })),
  ];
}

export function getModule4Point1CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule4Point2CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule5SubmittedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return withLabelText([
      { value: -1, text: 'Select', disabled: true },
      { value: 8, text: 'Module completed in full by due date; 100% completion status shown in platform', disabled: false },
      { value: 6, text: 'Module mostly completed 75–99%', disabled: false },
      { value: 4, text: 'Module less than 75% complete', disabled: false },
      { value: 0, text: 'Module not started or under 50% complete by the due date', disabled: false },
    ]);
  }
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    { value: 10, text: 'Module was submitted on time', disabled: false },
    { value: 6, text: 'Module was submitted late (within 24 hours after initial meeting)', disabled: false },
    { value: 3, text: 'Module was submitted significantly late (between 2 to 3 days after initial meeting)', disabled: false },
    { value: 0, text: 'Module was 4 or more days late or not submitted', disabled: false },
  ];
}

export function getModule5CompletedOptions() {
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    ...SENIOR_PLANNING_2.MODULE_5.COMPLETED.OPTIONS.filter((o) => o.value !== -1).map((o) => ({ ...o, disabled: false })),
  ];
}

export function getModule6SubmittedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, text: 'Select', disabled: true, label: 'Select' },
      {
        value: 8,
        text: 'Module completed in full by due date; 100% completion status shown in platform',
        disabled: false,
        label: 'Module completed in full by due date; 100% completion status shown in platform',
      },
      { value: 6, text: 'Module mostly completed 75–99%', disabled: false, label: 'Module mostly completed 75–99%' },
      { value: 4, text: 'Module less than 75% complete', disabled: false, label: 'Module less than 75% complete' },
      {
        value: 0,
        text: 'Module not started or under 50% complete by the due date',
        disabled: false,
        label: 'Module not started or under 50% complete by the due date',
      },
    ];
  }
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    { value: 10, text: 'Module was submitted on time', disabled: false },
    { value: 6, text: 'Module was submitted late (within 24 hours after initial meeting)', disabled: false },
    { value: 3, text: 'Module was submitted significantly late (between 2 to 3 days after initial meeting)', disabled: false },
    { value: 0, text: 'Module was 4 or more days late or not submitted', disabled: false },
  ];
}

export function getModule6CompletedOptions() {
  return [
    { value: -1, label: 'Select', text: 'Select', disabled: true },
    {
      value: 15,
      text: 'Module was thoughtfully completed by student (all 5 activities completely filled out with complete sentences, legible, and relevant answers)',
      disabled: false,
    },
    {
      value: 10,
      text: 'Module was completed by student but requires more work (all 5 activities completely filled out with needing work on sentence completion, and relevant answers)',
      disabled: false,
    },
    {
      value: 5,
      text: 'Module completion needs significant improvement (only 3 to 4 activities completely filled out)',
      disabled: false,
    },
    { value: 0, text: 'Module was not completed (2 or less activities completed or not turned in at all)', disabled: false },
  ];
}

export function getProfessionalJudgmentOptions() {
  return SENIOR_PLANNING_2.PROFESSIONAL_JUDGMENT.OPTIONS.map((option) => ({
    ...option,
    disabled: option.disabled !== undefined ? option.disabled : false,
  }));
}

export function getSocialSkillsOptions() {
  const options = SENIOR_PLANNING_2.SOCIAL_SKILLS.OPTIONS.filter((o) => o.value !== -1);
  return [{ value: -1, label: 'Select', text: 'Select', disabled: true }, ...options.map((o) => ({ ...o, disabled: false }))];
}

export function getDressedAppropriatelyOptions() {
  const options = SENIOR_PLANNING_2.DRESSED_APPROPRIATELY.OPTIONS.filter((o) => o.value !== -1);
  return [{ value: -1, label: 'Select', text: 'Select', disabled: true }, ...options.map((o) => ({ ...o, disabled: false }))];
}

export function getCommunicationOptions() {
  const options = SENIOR_PLANNING_2.COMMUNICATION.OPTIONS.filter((o) => o.value !== -1);
  return [{ value: -1, label: 'Select', text: 'Select', disabled: true }, ...options.map((o) => ({ ...o, disabled: false }))];
}

export function getParticipationOptions() {
  const options = SENIOR_PLANNING_2.PARTICIPATION.OPTIONS.filter((o) => o.value !== -1);
  return [{ value: -1, label: 'Select', text: 'Select', disabled: true }, ...options.map((o) => ({ ...o, disabled: false }))];
}

export function getWillingnessToAcceptFeedbackOptions() {
  const options = SENIOR_PLANNING_2.WILLINGNESS_TO_ACCEPT_FEEDBACK.OPTIONS.filter((o) => o.value !== -1);
  return [{ value: -1, label: 'Select', text: 'Select', disabled: true }, ...options.map((o) => ({ ...o, disabled: false }))];
}

export function getModule5Point1CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule5Point2CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule5Point3CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule5Point4CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule6Point1CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule6Point2CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule6Point3CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule6Point4CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 3, text: 'Student received a score of 95-100', disabled: false },
      { value: 2, text: 'Student received a score of 80-94', disabled: false },
      { value: 1, text: 'Student received a score of 65-79', disabled: false },
      { value: 0, text: 'Student received a score of 64 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule7Point1CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 2, text: 'Student received a score of 80-100', disabled: false },
      { value: 1, text: 'Student received a score of 61-79', disabled: false },
      { value: 0, text: 'Student received a score of 60 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule7Point2CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 2, text: 'Student received a score of 80-100', disabled: false },
      { value: 1, text: 'Student received a score of 61-79', disabled: false },
      { value: 0, text: 'Student received a score of 60 or below', disabled: false },
    ];
  }
  return [];
}

export function getModule7Point3CompletedOptions(version) {
  if (version === PLANNING_MEETING_FORM_VERSION) {
    return [
      { value: -1, label: 'Select', text: 'Select', disabled: true },
      { value: 2, text: 'Student received a score of 80-100', disabled: false },
      { value: 1, text: 'Student received a score of 61-79', disabled: false },
      { value: 0, text: 'Student received a score of 60 or below', disabled: false },
    ];
  }
  return [];
}

/**
 * Calculates the overall total score for the form, supporting both version 2 and legacy versions.
 * @param {object} form - The form object containing all scoring fields.
 * @returns {number} The total score.
 */
export function calculateOverallTotalScore(form) {
  const isVersionTwo = form.version && form.version === PLANNING_MEETING_FORM_VERSION;
  if (isVersionTwo) {
    return (
      (form.gradingSheet2Completed && form.gradingSheet2Completed >= 0 ? form.gradingSheet2Completed : 0) +
      (form.gradingSheet2Submitted && form.gradingSheet2Submitted >= 0 ? form.gradingSheet2Submitted : 0) +
      (form.socialSkills && form.socialSkills >= 0 ? form.socialSkills : 0) +
      (form.dressedAppropriately && form.dressedAppropriately >= 0 ? form.dressedAppropriately : 0) +
      (form.communication && form.communication >= 0 ? form.communication : 0) +
      (form.participation && form.participation >= 0 ? form.participation : 0) +
      (form.willingnessFeedback && form.willingnessFeedback >= 0 ? form.willingnessFeedback : 0) +
      (form.module4Submitted && form.module4Submitted >= 0 ? form.module4Submitted : 0) +
      (form.module4Point1Completed && form.module4Point1Completed >= 0 ? form.module4Point1Completed : 0) +
      (form.module4Point2Completed && form.module4Point2Completed >= 0 ? form.module4Point2Completed : 0) +
      (form.module5Submitted && form.module5Submitted >= 0 ? form.module5Submitted : 0) +
      (form.module5Point1Completed && form.module5Point1Completed >= 0 ? form.module5Point1Completed : 0) +
      (form.module5Point2Completed && form.module5Point2Completed >= 0 ? form.module5Point2Completed : 0) +
      (form.module5Point3Completed && form.module5Point3Completed >= 0 ? form.module5Point3Completed : 0) +
      (form.module5Point4Completed && form.module5Point4Completed >= 0 ? form.module5Point4Completed : 0) +
      (form.module6Submitted && form.module6Submitted >= 0 ? form.module6Submitted : 0) +
      (form.module6Point1Completed && form.module6Point1Completed >= 0 ? form.module6Point1Completed : 0) +
      (form.module6Point2Completed && form.module6Point2Completed >= 0 ? form.module6Point2Completed : 0) +
      (form.module6Point3Completed && form.module6Point3Completed >= 0 ? form.module6Point3Completed : 0) +
      (form.module6Point4Completed && form.module6Point4Completed >= 0 ? form.module6Point4Completed : 0) +
      (form.module7Point1Completed && form.module7Point1Completed >= 0 ? form.module7Point1Completed : 0) +
      (form.module7Point2Completed && form.module7Point2Completed >= 0 ? form.module7Point2Completed : 0) +
      (form.module7Point3Completed && form.module7Point3Completed >= 0 ? form.module7Point3Completed : 0)
    );
  } else {
    return (
      (form.gradingSheet2Completed && form.gradingSheet2Completed >= 0 ? form.gradingSheet2Completed : 0) +
      (form.gradingSheet2Submitted && form.gradingSheet2Submitted >= 0 ? form.gradingSheet2Submitted : 0) +
      (form.gradingSheet2Clarity && form.gradingSheet2Clarity >= 0 ? form.gradingSheet2Clarity : 0) +
      (form.module4Submitted && form.module4Submitted >= 0 ? form.module4Submitted : 0) +
      (form.module4Completed && form.module4Completed >= 0 ? form.module4Completed : 0) +
      (form.module5Submitted && form.module5Submitted >= 0 ? form.module5Submitted : 0) +
      (form.module5Completed && form.module5Completed >= 0 ? form.module5Completed : 0) +
      (form.module6Submitted && form.module6Submitted >= 0 ? form.module6Submitted : 0) +
      (form.module6Completed && form.module6Completed >= 0 ? form.module6Completed : 0)
    );
  }
}

/**
 * Improved: Validates disposition fields for Planning Form 2.
 * @param {object} form - The form object.
 * @param {boolean} showIncomplete - Whether to show incomplete fields.
 * @returns {{rc: boolean, requiredFields: Array}} - rc: true if valid, requiredFields: array of missing requirements.
 */
export function validateDispositionFields(form, showIncomplete) {
  // Only validate if status is relevant
  if (!['approved', 'incomplete'].includes(form.status) && !showIncomplete) {
    return { rc: true, requiredFields: [] };
  }

  // Define required fields by version
  const requiredFieldsByVersion = {
    2: [
      'gradingSheet2Completed',
      'gradingSheet2Submitted',
      'socialSkills',
      'dressedAppropriately',
      'communication',
      'participation',
      'willingnessFeedback',
      'module4Submitted',
      'module4Point1Completed',
      'module4Point2Completed',
      'module5Submitted',
      'module5Point1Completed',
      'module5Point2Completed',
      'module5Point3Completed',
      'module5Point4Completed',
      'module6Submitted',
      'module6Point1Completed',
      'module6Point2Completed',
      'module6Point3Completed',
      'module6Point4Completed',
      'module7Point1Completed',
      'module7Point2Completed',
      'module7Point3Completed',
    ],
    legacy: [
      'gradingSheet2Completed',
      'gradingSheet2Submitted',
      'gradingSheet2Clarity',
      'module4Submitted',
      'module4Completed',
      'module5Submitted',
      'module5Completed',
      'module6Submitted',
      'module6Completed',
    ],
  };

  // Select required fields for this form version
  const version = form.version === PLANNING_MEETING_FORM_VERSION ? PLANNING_MEETING_FORM_VERSION : 'legacy';
  const requiredFields = requiredFieldsByVersion[version];

  // Find missing or invalid fields
  const missingFields = requiredFields.filter(
    (field) => form[field] === undefined || form[field] === null || (typeof form[field] === 'number' && form[field] < 0)
  );

  if (missingFields.length > 0) {
    return {
      rc: false,
      requiredFields: [
        {
          requirement: 'You must score the application before approving. Please score each item before changing the status to approved.',
          missingFields,
        },
      ],
    };
  }

  return { rc: true, requiredFields: [] };
}
